// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BidItemsModalQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.BidItemFilter>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type BidItemsModalQuery = { __typename?: 'Query', bidItemsPage: { __typename?: 'BidItemsPage', bidItems: Array<{ __typename?: 'BidItem', code: string, id: string, name: string }>, pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type BidItemsModal_BidItemFragment = { __typename?: 'BidItem', code: string, id: string, name: string };

export const BidItemsModal_BidItemFragmentDoc = gql`
    fragment BidItemsModal_BidItem on BidItem {
  ...Named
  code
}
    ${NamedFragmentDoc}`;
export const BidItemsModalDocument = gql`
    query BidItemsModal($filter: BidItemFilter, $first: Int, $offset: Int) {
  bidItemsPage(filter: $filter, first: $first, offset: $offset) {
    bidItems {
      ...BidItemsModal_BidItem
    }
    pageInfo {
      totalCount
    }
  }
}
    ${BidItemsModal_BidItemFragmentDoc}`;

/**
 * __useBidItemsModalQuery__
 *
 * To run a query within a React component, call `useBidItemsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidItemsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidItemsModalQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useBidItemsModalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BidItemsModalQuery, BidItemsModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidItemsModalQuery, BidItemsModalQueryVariables>(BidItemsModalDocument, options);
      }
export function useBidItemsModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidItemsModalQuery, BidItemsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidItemsModalQuery, BidItemsModalQueryVariables>(BidItemsModalDocument, options);
        }
// @ts-ignore
export function useBidItemsModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BidItemsModalQuery, BidItemsModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidItemsModalQuery, BidItemsModalQueryVariables>;
export function useBidItemsModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidItemsModalQuery, BidItemsModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidItemsModalQuery | undefined, BidItemsModalQueryVariables>;
export function useBidItemsModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidItemsModalQuery, BidItemsModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidItemsModalQuery, BidItemsModalQueryVariables>(BidItemsModalDocument, options);
        }
export type BidItemsModalQueryHookResult = ReturnType<typeof useBidItemsModalQuery>;
export type BidItemsModalLazyQueryHookResult = ReturnType<typeof useBidItemsModalLazyQuery>;
export type BidItemsModalSuspenseQueryHookResult = ReturnType<typeof useBidItemsModalSuspenseQuery>;
export type BidItemsModalQueryResult = Apollo.QueryResult<BidItemsModalQuery, BidItemsModalQueryVariables>;